const ROUTING_REASON_KEYS: Record<string, string> = {
  MaxVariationExceeded: 'MaxVariationExceeded',
  MaxPassengersExceeded: 'FullCapacity',
  MaxPrmPassengersExceeded: 'FullCapacity',
  MaxCostAndMaxPassengersExceeded: 'FullCapacity',
  MaxCostExceeded: 'ReservationExceedsTime',
  CouldNotFitSolution: 'RouteIncompatible',
};

// The algorithm's reasons are finer than the texts the cards show, so the rest read as an impossible trip
export function routingReasonKey(reason: unknown): string {
  return (typeof reason === 'string' && ROUTING_REASON_KEYS[reason]) || 'Impossible';
}
